import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";

const initialState = {
  studentDetails: [],
  loading: false,
  error: "",
};
export const StudentDetails = createAsyncThunk(
  "studentDetails/api",
  ({ instanceState, trainingID }) => {
    return api_call(
      "POST",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].SUPPORT +
        API.END_POINTS.FAILEDTRAININGDETAILS,
      {},
      {},
      {
        instanceState,
        trainingId: trainingID,
      }
    );
  }
);
const StudentDetailsSlice = createSlice({
  name: "studentDetails",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(StudentDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(StudentDetails.fulfilled, (state, action) => {
      console.log("Monitor studentDetails", action.payload);
      state.loading = false;
      state.studentDetails = action.payload;
      state.error = "";
    });
    builder.addCase(StudentDetails.rejected, (state, action) => {
      state.loading = false;
      state.studentDetails = [];
      state.error = action.error.message;
    });
  },
});

export const failedTrainingDetails = {
  StudentDetails: StudentDetailsSlice.reducer,
};
